package com.essntl.features.category.ui.addeditcategory

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddEditCategoryValidation {
    val addEditCategoryForm = AddEditCategoryForm()
}

class AddEditCategoryForm : Form() {
    val name =
        StringField(NonEmptyValidator)

    val iconUrl =
        StringField(NonEmptyValidator)

    override val fields: List<Field> =
        listOf(
            name,
            iconUrl,
        )
}